import React from 'react';
import PropTypes from 'prop-types';
// styles
import {
  ColContentContainerStyled,
  ColPictureContainerStyled,
  PictureStyled,
  RowStyled,
  SectionContainerStyled,
  TypographyStyledHeading,
  TypographyTitleStyled,
} from './styles';

const getPicture = (
  imageAlt,
  image,
) => {
  return (
    <PictureStyled
      lazyLoad
      variant='rectangular'
      src={image}
      altText={imageAlt}
    />
  );
};

export const LeadersTwoColumnContentComponent = ({
  className,
  content,
  header,
  id,
  image,
  imageAlt,
  isExecutiveVicePresident,
  isLastItem,
  reversed,
  sectionBackgroundVariant,
  title,
}) => (
  <SectionContainerStyled
    id={id}
    backgroundVariant={sectionBackgroundVariant}
    themeType='lightTheme'
    className={className}
    isLastItem={isLastItem}>
    <div
      itemScope
      itemType='https://schema.org/Person'>
      <RowStyled
        reversed={reversed}
        align='center'>
        <ColPictureContainerStyled
          itemProp='image'
          align='center'
          small={10}
          medium={5}>
          {getPicture(
            imageAlt,
            image,
          )}
        </ColPictureContainerStyled>
        <ColContentContainerStyled
          small={10}
          medium={7}
          reversed={reversed}>
          <TypographyStyledHeading
            itemProp='name'
            component='h2'>
            {header}
          </TypographyStyledHeading>
          {isExecutiveVicePresident && (
            <TypographyTitleStyled
              component='h3'
              itemProp='jobTitle'
              disableBottomPadding>
              Executive Vice President
            </TypographyTitleStyled>
          )}
          <TypographyTitleStyled
            itemProp='jobTitle'
            component='h3'>
            {title}
          </TypographyTitleStyled>
          {content}
        </ColContentContainerStyled>
      </RowStyled>
    </div>
  </SectionContainerStyled>
);

LeadersTwoColumnContentComponent.propTypes = {
  className: PropTypes.string,
  content: PropTypes.any,
  isExecutiveVicePresident: PropTypes.bool,
  header: PropTypes.any,
  id: PropTypes.string,
  imageAlt: PropTypes.string,
  image: PropTypes.any,
  reversed: PropTypes.bool,
  sectionBackgroundVariant: PropTypes.string,
  title: PropTypes.any,
};

LeadersTwoColumnContentComponent.defaultProps = {
  className: null,
  reversed: false,
  sectionBackgroundVariant: 'lightA',
};

export default LeadersTwoColumnContentComponent;
